export default __webpack_public_path__ + "static/media/NEOXIS_logo_inline.6fb0fee4.png";